import CastingOverview from './CastingOverview'

const Casting = (): JSX.Element | null => {
	return <CastingOverview />
}

export default Casting
